import React, { useState, useEffect, useRef } from "react";
import Card from "@mui/material/Card";
import { Box, Typography, MenuItem, Select, Input } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import axiosInstance from "../../helpers/axios.js";
import TextField from "@mui/material/TextField";
import moment from "moment/moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from 'jwt-decode';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Backdrop from "@mui/material/Backdrop";
import dayjs from "dayjs";
import Modal from "@mui/material/Modal";
import EditForm from "./editForm.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  maxHeight: "95vh",
  overflowY: "auto",
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
  "&::-webkit-scrollbar": {
    width: "0.4em",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
  },
};

const modelstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};


export default function AddStudent() {
  
  let user = null;

  if (typeof sessionStorage !== "undefined") {
    user = sessionStorage.getItem("user");
  }

  let decode = "";
  if (typeof user === "string") {
    decode = jwt_decode(user);
  }

  const dispatch = useDispatch();
  const [kycData, setKycData] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [nameAsPerPAN, setNameAsPerPAN] = useState("");
  const [pan, setPAN] = useState("");
  const [DOB, setDOB] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [studentMobileNumber, setStudentMobileNumber] = useState("");


  const handleFileDrop = (setter) => (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setter(acceptedFiles[0].name); // Store the file name
    }
  };
  const handleFileRemove = (setter) => () => {
    setter(null); // Clear the file name
  };
  const validate = () => {
    const newErrors = {};
    if (!firstName) newErrors.firstName = "Student Name is required";
    if (!nameAsPerPAN) newErrors.nameAsPerPAN = "Name As Per PAN is required";
    if (!pan) newErrors.pan = "PAN is required";
    if (!DOB) newErrors.DOB = "Date of Birth is required";
    else if (dayjs().diff(dayjs(DOB), "year") <= 18)
      newErrors.DOB = "Must be at least 18 years old";
    if (!mobileNumber) newErrors.mobileNumber = "Mobile number is required";
    else if (!/^\d{10}$/.test(mobileNumber))
      newErrors.mobileNumber = "Invalid mobile number";
    if (!studentMobileNumber) {
      newErrors.studentMobileNumber = "Student Mobile number is required";
    } else if (!/^\d{10}$/.test(studentMobileNumber)) {
      newErrors.studentMobileNumber = "Invalid Student mobile number";
    }
  
    if (mobileNumber && studentMobileNumber && mobileNumber === studentMobileNumber) {
      newErrors.mobileNumber = "Applicant and Student mobile numbers cannot be the same";
      newErrors.studentMobileNumber = "Applicant and Student mobile numbers cannot be the same";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {

    if (validate()) {
      // handle form submission
      handleOpened();
      handleStartSession();

    }
  };

  // useEffect(() => {
  //   let queryParams = {}
  //   if(decode){
  //     queryParams.instituteId = decode.instituteId;
  //   }
  //   axiosInstance
  //     .get("rules/get-qec", {
  //       params: queryParams
  //     })
  //     .then((res) => {
  //       setTableData(res?.data?.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  

  const [opened, setOpened] = useState(false);
  const [openeligible, setOpeneligible] = useState(false); // Define open state variable
  const[eligible,setEligible]=useState("");
  const handleOpened = () => setOpened(true);
  const handleCloseConsent = () => setOpened(false);
  const handleClosed = () => {
    setOpen(false); // Update open state variable to false
  };

  const [link, setLink] = useState("");

  const handleStartSession = () => {
    const randomGen =
      Date.now().toString(36) + Math.random().toString(36).substr(2);

    window
      .getBureauSession(
        "74265ef8ad1a440ab45999fc061e6205",
        randomGen,
        nameAsPerPAN,
        "",
        "",
        mobileNumber
      )
      .then((res) => {
        console.log(res);

        handleOpened();
        handleClose();
        setLink(res);
      });
  };

  const [submitAuth,setSubmitAuth] = useState("")
  const handleLoadSession = async () => {
    const result = await window.startBureauSession();
    if (result) {
      switch (result.status) {
        case "SUCCESS":
          const body1 = {
            firstName: "",
            lastName: "",
            dob: moment(DOB).format("DD/MM/YYYY"),
            gender: "",
            email: "",
            mobile: mobileNumber,
            panId: pan,
            aadhaarId: "",
            currentAddress: " ",
            currentCity: " ",
            currentState: " ",
            currentPincode: " ",
            panImage: " ",
            aadhaarFrontImage: " ",
            aadhaarBackImage: " ",
            employmentType: " ",
            employerName: " ",
            salary: 0,
            typeOfBusiness: " ",
            incomePerMonth: 0,
            employmentCity: " ",
            courseFees: 0,
            instituteName: decode?.instituteName,
            studentName: firstName,
            courseName: " ",
            channelId: "6",
            studentMobile:studentMobileNumber
          };
          axiosInstance.post("pay-later-flow/create", body1).then((res) => {
            const kyc = res?.data?.data
            setKycData(kyc);
            setUserid(kyc?.userId);
            SetApplicationsid(kyc?.application)
            console.log(res?.data?.data?.application,'aplllkvfdv')
            const body = { 
              memberId: "d732d532-c9d5-4207-864f-ae96ec05ac6b" };
              axiosInstance.post(`/login/auth`, body)
                .then((res) => {
                  const token = res?.data?.data;
                  setSubmitAuth(token)
                  
                const data2 = { 
                  userId: kycData.userId,
                  latitude : 0,
                longitude : 0, };
            
                  
                axiosInstance.post(`/end-user/submit/qec`, data2,{
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                    .then((res) => {
                      console.log(res)
                    })
                    .catch((error) => console.log("error", error));
  
                })
                .catch((error) => console.log("error", error));
           
            const qecBody = {
              applicationId: kyc?.application,
              userId: kyc?.userId,
              instituteId: decode?.instituteId,
              studentName: firstName,
              applicantName: kyc?.firstName + " " + kyc?.lastName,
              panId: pan,
              dob: moment(DOB).format("DD/MM/YYYY"),
              phone: mobileNumber,
              status: "Created",
              eligibility: 3,
            };
  
            axiosInstance
              .post("rules/create/eligibility", qecBody)
              .then((result) => {
                axiosInstance.get(`/rules/eligibility?phone=${mobileNumber}`)
                    .then((res)=>{
                      console.log(res?.data?.data?.status,'statuss')
                      setEligible(res?.data?.data?.status);
                      localStorage.setItem('eligibility_status', res?.data?.data?.status);
                      
                      setOpeneligible(true)
  
                  })
                    .catch((error) => {
                      console.error("Error fetching eligibility:", error);
                    });
                setFirstName("");
                setNameAsPerPAN("");
                setPAN("");
                setDOB(null);
                setMobileNumber("");
                setStudentMobileNumber("")
                setErrors({});
               
              });
  
    
          }).catch((err)=>{
            console.log(err)
          })
    
          break;

        case "EXIT":
          alert("Retry Submit");
          handleCloseConsent();
          break;

        case "ERROR":
          alert("Error Please Try Later");
          handleCloseConsent();
          break;

        default:
          alert("Contact our team for assistance");
          break;
      }
    }
  };


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [editFormModal,setEditFormModal]=useState(false);
  const [errors, setErrors] = useState({});
  const[userIds,setUserid]=useState("")
  const[applicationId,SetApplicationsid]=useState("")
  const [shouldFetch, setShouldFetch] = useState(true);
  const [userData, setUserData] = useState({});
  

  

  useEffect(() => {
    if (shouldFetch && userIds && applicationId) {
      console.log(userIds,applicationId,'tptal')
      const urlProfile = `/summary/user?id=${userIds}&applicationId=${applicationId}`;
      axiosInstance.get(urlProfile).then((res) => {
        const data = res?.data?.data;
        console.log( res?.data?.data,"userdatastd1")
        setUserData({
          applicationId:data?.applicationId,
          userId:data?.userId,
          instituteName: data.instituteName,
          courseName: data.courseName,
          courseFees: data.courseFees,
          email: data.email,
          dob: data.dateOfBirth,
          gender: data.gender,
          tenure: data.loanTenure,
          firstName: data.firstName,
          lastName: data.lastName,
          mobile: data.mobile,
          currentAddress: data.currentAddress,
          officeAddress: data.officeAddress,
          maritalStatus: data.maritalStatus,
          studentName: data.studentName,
          salary: data.salary,
          panId: data.panId,
          aadhaarId: data.aadhaarId,
          currentPincode: data.currentPincode,
          currentCity: data.currentCity,
          currentState: data.currentState,
          officePincode: data.officePincode,
          officeCity: data.officeCity,
          officeState: data.officeState,
        });
        setShouldFetch(false); // Reset shouldFetch after fetching data
      }).catch(error => {
        console.error("Error fetching user data:", error);
        setShouldFetch(false);
      });
    }
  }, [shouldFetch, userIds, applicationId]); // Dependencies for useEffect



  const handleEligible = () => {
     
    setEditFormModal(true); 
    setShouldFetch(false);

  
       
  };
  

  const handleeditform = () => {
    
   
    setOpeneligible(false);  
   
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        keepMounted
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box sx={style} className="dark-BG-101010">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "8px",
              padding: "20px 20px",
            }}
          
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontWeight: "500",
                fontSize: "20px"
              }}
            >
              Eligibility check
            </Typography>
            <IconButton
              aria-label="remove"
              size="small"
              onClick={handleClose}
              className="modal-close"
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box component="form" noValidate>
            <Box
              sx={{
                background: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
              }}
              className="dark-BG-101010"
            >
              <Grid
                container
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                    Applicant Name
                  </Typography>
                  <TextField
                    autoComplete="given-name"
                    name="Applicant Name"
                    fullWidth
                    id="Applicant Name"
                    label="Applicant Name"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                    Name As Per PAN
                  </Typography>
                  <TextField
                    autoComplete="given-name"
                    name="Name As Per PAN"
                    fullWidth
                    id="Name As Per PAN"
                    label="Name As Per PAN"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                    value={nameAsPerPAN}
                    onChange={(e) => setNameAsPerPAN(e.target.value)}
                    error={!!errors.nameAsPerPAN}
                    helperText={errors.nameAsPerPAN}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                    PAN
                  </Typography>
                  <TextField
                    autoComplete="given-name"
                    name="PAN"
                    fullWidth
                    id="PAN"
                    label="PAN"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                   
                    value={pan}
                    onChange={(e) => setPAN(e.target.value.toUpperCase())}
                    error={!!errors.pan}
                    helperText={errors.pan}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                    Date of Birth
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date of Birth"
                      value={DOB}
                      format="DD/MM/YYYY"
                      onChange={(date) => setDOB(date?.$d)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.DOB}
                          helperText={errors.DOB}
                          InputProps={{
                            style: { borderRadius: 10 },
                          }}
                        />
                      )}
                      sx={{ width: "100%" }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                  Applicant Mobile
                  </Typography>
                  <TextField
                    autoComplete="given-name"
                    name="mobile"
                    fullWidth
                    id="mobile"
                    label="Applicant Mobile"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    error={!!errors.mobileNumber}
                    helperText={errors.mobileNumber}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    as="h5"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "12px",
                    }}
                  >
                  Student Mobile
                  </Typography>
                  <TextField
                    autoComplete="given-name"
                    name="mobile"
                    fullWidth
                    id="mobile"
                    label="Student Mobile"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                    value={studentMobileNumber}
                    onChange={(e) => setStudentMobileNumber(e.target.value)}
                    error={!!errors.studentMobileNumber}
                    helperText={errors.studentMobileNumber}
                  />
                </Grid>
                <Grid item xs={12} textAlign="center">
                  <Button
                    type="button"
                    variant="contained"
                    sx={{
                      mt: 5,
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      fontWeight: "500",
                      fontSize: "13px",
                      padding: "12px 20px",
                      color: "#fff !important",bgcolor:'#d32028'
                    }}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    SUBMIT
                  </Button>
                </Grid>
                
          
                <Modal open={openeligible} onClose={() => {handleEligible();handleeditform()}}>
              <Box sx={modelstyle}>
              
                   <Typography variant="h6" component="h2">
                  Eligibility Status
                 
                 </Typography>
                  <IconButton 
               onClick={() => {  handleeditform(); }} 
             sx={{ position: 'absolute', top: 8, right: 8 }} 
             >
             <CloseIcon />
            </IconButton>
                <Typography variant="body1" sx={{ mt: 2 }}>
                {eligible !== null ? (
                 eligible === 3 || eligible === 1 ? (
                       <h1>Approved,click 'ok' to  complete your application</h1>
                 ) : (
                      <h1>Rejected</h1>
                 )
                   ) : (
                     "Eligibility status not available.")}
          </Typography>
           {eligible !== null ? (
        eligible === 2 ? (
    <Button onClick={handleeditform} variant="contained" sx={{ mt: 3 }}>
      Close
    </Button>):(
       <Button onClick={()=>handleEligible(userIds,applicationId)} variant="contained" sx={{ mt: 3 }}>
       ok
     </Button>)
    ): (
      "Eligibility status not available."
    )
  }
  </Box>
</Modal>
 {/* EditForm Modal */}
 {editFormModal && (
        <EditForm  formOpen={editFormModal} setFormOpen={setEditFormModal}  userData={userData} />
      )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Card
        sx={{
          width:"100%",
          boxShadow: "none",
          borderRadius: "10px",
          
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="for-dark-bottom-border"
        >
          {/* eligibility  check button  */}

          <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "13px",
              padding: "12px 20px",
              color: "#fff !important",bgcolor:'#d32028'
            }}
            onClick={handleOpen}
          >
            <AddIcon
              sx={{ position: "relative", top: "-1px" }}
              className="mr-5px"
            />{" "}
            Eligibility Check
          </Button>

          {/* export button got added on 7/8/2024 */}
          {/* <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "13px",
              padding: "12px 20px",
              padding: "20px",
              color: "#fff !important",
              height: "35px",
              margin: "10px",
            }}
            onClick={() => handleDownloadExcel()}
          >
            <GetAppIcon
              sx={{ position: "relative", top: "-1px" }}
              className="mr-5px"
            />{" "}
            Export
          </Button> */}
        </Box>
      </Card>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={opened}
        keepMounted
        closeAfterTransition sx={{overflow:'auto'}}
      >
        <Box>
          <Box
            style={{ backgroundColor: "white", padding: "10px" }}
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "18rem",
              alignItems: "center",
              borderRadius: "8px",
              padding: "20px 20px",
            }}
            className="bg-black"
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontWeight: "500",
                fontSize: "20px",
              }}
            >
              OTP Consent
            </Typography>
            <IconButton
              style={{ border: "2px solid #DbDbDb" }}
              aria-label="remove"
              size="small"
              onClick={handleCloseConsent}
              className="modal-close"
            >
              <ClearIcon />
            </IconButton>
          </Box>

          <Box display="flex" justifyContent="center" alignItems="center">
            <iframe
              width="450"
              height="630"
              src={link}
              onLoad={handleLoadSession}
              title="bureau"
            ></iframe>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
